// GENERATED from yesco-400317.yesco_fusegrid.franchise_map (2026-07-13).
// Regenerate via server/scripts/yesco_fusegrid/README.md runbook when franchises change.
export interface ExpectedFranchise {
  profileId: string
  name: string
}

export const YESCO_EXPECTED_FRANCHISES: ExpectedFranchise[] = [
  { profileId: '1', name: 'YESCO Arkansas Northwest' },
  { profileId: '2', name: 'YESCO Houston South/Dallas South' },
  { profileId: '3', name: 'Yesco Southwestern Ontario' },
  { profileId: '4', name: 'BROOKLIN SIGNS & GRAPHICS INC.' },
  { profileId: '5', name: 'Chase Sign & Lighting Service' },
  { profileId: '6', name: 'Liechty Von Hoven Ventures Inc dbaYESCO Indy South' },
  { profileId: '7', name: 'KJ SIGNS, LLC dba Signarama Ankeny/YESCO Des Moines' },
  { profileId: '8', name: 'YESCO Hampton Roads/Richmond' },
  { profileId: '9', name: 'YESCO Concord-Nashua' },
  { profileId: '10', name: 'YESCO Rapid City' },
  { profileId: '11', name: 'YESCO Calgary' },
  { profileId: '12', name: 'YESCO Sign & Lighting division of Dallas Sign & Lighting' },
  { profileId: '13', name: 'YESCO Tampa' },
  { profileId: '14', name: 'YESCO Central Texas | Sign Source, Inc.' },
  { profileId: '15', name: 'YESCO Ontario East' },
  { profileId: '16', name: 'YESCO Sign & Lighting division of Alabama Sign & Lighting' },
  { profileId: '17', name: 'Yesco Cleveland/Heritage Sign & Lighting' },
  { profileId: '18', name: 'YESCO Twin Cities' },
  { profileId: '19', name: 'YESCO Illinois Central' },
  { profileId: '20', name: 'YESCO MID ATLANTIC' },
  { profileId: '21', name: 'YESCO Wichita' },
  { profileId: '22', name: 'YESCO Cincinnati' },
  { profileId: '23', name: 'YESCO Nashville / Florida Panhandle' },
  { profileId: '24', name: 'YESCO St. Louis' },
  { profileId: '25', name: 'YESCO Kansas City' },
  { profileId: '26', name: 'YESCO Louisville' },
  { profileId: '27', name: 'Yesco Sign & Lighting' },
  { profileId: '28', name: 'YESCO Virginia North' },
  { profileId: '29', name: 'YESCO Orlando South' },
  { profileId: '30', name: 'YESCO Lima' },
  { profileId: '31', name: 'YESCO Lafayette' },
  { profileId: '32', name: 'METRO SIGN INC' },
  { profileId: '33', name: 'YESCO Indianapolis North' },
  { profileId: '34', name: 'YESCO-Vaughan' },
  { profileId: '35', name: 'YESCO Oklahoma & New England South' },
  { profileId: '36', name: 'YESCO Myrtle Beach / Charleston' },
  { profileId: '37', name: 'YESCO Surrey' },
  { profileId: '38', name: 'YESCO South Dakota East' },
  { profileId: '39', name: 'YESCO Suffolk County' },
  { profileId: '40', name: 'YESCO Triad' },
  { profileId: '41', name: 'Yesco Edmonton' },
  { profileId: '42', name: 'YESCO Pennsylvania South/Central' },
  { profileId: '43', name: 'YESCO North Carolina East' },
  { profileId: '44', name: 'YESCO Ohio East/Pittsburgh' },
  { profileId: '45', name: 'Spears Inc DBA Yesco Augusta' },
  { profileId: '46', name: 'YESCO Arkansas Central' },
  { profileId: '47', name: 'YESCO Atlanta Central' },
  { profileId: '48', name: 'YESCO Fort Myers' },
  { profileId: '49', name: 'Frank Balton & Co, Inc' },
  { profileId: '50', name: 'YESCO New Jersey Central and South' },
  { profileId: '51', name: 'YESCO Omaha' },
  { profileId: '52', name: 'YESCO Virginia North' },
  { profileId: '53', name: 'YESCO Wisconsin Central' },
  { profileId: '54', name: 'YESCO Sign and Lighting of Ann Arbor' },
  { profileId: '55', name: 'Crannie Service LLC' },
  { profileId: '56', name: 'Rainbow South LLC' },
  { profileId: '57', name: 'YESCO Columbus' },
  { profileId: '58', name: 'C&C RIDGEWAY LLC' },
  { profileId: '59', name: 'DBA:  Florida Branding Solutions/YESCO Fort Lauderdale' },
  { profileId: '60', name: 'Malds Jobir Inc,   DBA  YESCO New Jersey North' },
  { profileId: '61', name: 'Baysigns LLC' },
]
